export default "__VITE_ASSET__ClfyCWL0__"